import { inview } from '../../lib/inview';

export function relate(page) {


	//console.log(regionArr);
	let regionDelay = 50;


	// relateBox01 / relateBox02 で同じ処理だったのでまとめた
	[document.getElementById('relateBox01'), document.getElementById('relateBox02')].forEach((box) => {
		const boxes = box.querySelectorAll(".box");
		const timeLine = [];

		inview(box, (direction) => {
			if (direction == "down") {
				for (var i = 0; i < boxes.length; i++) {
					let eachJob = boxes[i];

					timeLine[i] = setTimeout(function () {
						eachJob.classList.add("active");
					}, regionDelay * i);
				}
			} else {
				for (var i = 0; i < boxes.length; i++) {
					clearTimeout(timeLine[i]);
					boxes[i].classList.remove("active");
				}
			}
		}, '70%');
	});
}

